module.exports = __webpack_public_path__ + "img/company20.10c4c3b3.png";